import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'semantic-ui-react';
import isEqual from 'lodash/isEqual';
import FieldStatusIcon from "components/forms/FieldStatusIcon";
import {injectIntl, intlShape} from 'react-intl';

/*
Note: would love to get rid of this and use a plain Dropdown component.
This component currently deals with the [messy] details or formatting 
the selected category as a string array in the shape [<parent category>, <subcategory>].
That logic could be moved from here into BreakCategoryEditorConnected

*/

class BreakSiteCategoryDropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.makeState(props);
    }

    componentWillReceiveProps(props, context) {
        const nextState = this.makeState(props);

        if (!isEqual(this.state, nextState)) {
            this.setState(nextState, () => {
                this.props.onValueChanged(this.state.selectedCategories, this.props.currentPlatform);
            });
        }
    }

    makeState(props) {
        let providedCategories = props.defaultValue || [];

        return {
            selectedCategories: providedCategories
        };
    }

    containsCategory(category) {
        return this.state.selectedCategories.indexOf(category) > -1;
    }

    primaryCategoryOfSub(subcategory) {
        for (let primaryCategory of this.props.categories) {
            if (primaryCategory.subcategories.indexOf(subcategory) > -1) {
                return primaryCategory;
            }
        }
        return null;
    }

    toggleCategory(category) {
        let selectedPrimary = this.primaryCategoryOfSub(category);
        let newCategories = [selectedPrimary.category, category];

        this.setState({
            selectedCategories: newCategories
        });

        this.props.onValueChanged(newCategories, 'categories', null);
    }

    render() {
        let isSaving = this.props.isSaving;
        let error = this.props.error;
        let savedField = this.props.savedField;

        let value = null
        if (this.props.defaultValue && (this.props.defaultValue.length === 2)) {
            value = this.props.defaultValue[1]
        }

        // let options1 = (this.props.categories || []) 
        //         .map((category) => {
        //             console.log(`category`, category)

        //             // return {
        //             //     value: category.category,
        //             //     text: category.category 
        //             // };  

        //             return category.subcategories.map((subcategory, index) => {
        //                 console.log(`subcategory`, subcategory)
        //                 return {
        //                     value: subcategory,
        //                     text: category.category + ' - ' + subcategory
        //                   };                        

        //             })
        //         })

        // console.log(`options1`, options1)


        // let options = (this.props.categories || []) 
        //     .reduce((previous, category, index) => {
        //         // console.log(`reduce category`, category)

        //         // return {
        //         //     value: category.category,
        //         //     text: category.category 
        //         // };  

        //         let subcategories =  category.subcategories.map((subcategory, index) => {
        //             // console.log(`subcategory`, subcategory)
        //             return {
        //                 value: subcategory,
        //                 text: category.category + ' - ' + subcategory
        //               };                        

        //         })

        //         return previous.concat(subcategories)
        //     }, [])
        // // console.log(`options`, options)

        let options = this.props.options
        let options1 = this.props.options.map((option, i) => {

            return (
                <Dropdown.Item key={i} value={option.value} text={this.props.intl.formatMessage({id: `editbreak.breaksNavFilters.${option.text}`})} />
            )
            })

        

        return (
            <section >
                <div className="row db-field-label-row"><div className="ui basic label db-field-label"><span>Category</span></div></div>

                <Dropdown
                    selection={true}
                    openOnFocus={false}
                    selectOnBlur={false}
                    closeOnChange={true}
                    selectOnNavigation={false}
                    options={options}
                    loading={isSaving}
                    onChange={(event, data) => this.toggleCategory(data.value)}
                    defaultValue={value}
                    className=''
                />

                <FieldStatusIcon error={error} saved={savedField} isSaving={false} show={true}/>

            </section>
        );
    }
}

BreakSiteCategoryDropdown.propTypes = {
    onValueChanged: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({
        category: PropTypes.string.isRequired,
        subcategories: PropTypes.arrayOf(PropTypes.string).isRequired
    })),
    value: PropTypes.shape({
        MASTER: PropTypes.any,
        DAILYBREAK: PropTypes.any,
        EMBED: PropTypes.any,
        DEMO: PropTypes.any,
    }).isRequired,
};

BreakSiteCategoryDropdown.defaultProps = {
    categories: []
};

export default injectIntl(BreakSiteCategoryDropdown);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/BreakSite/BreakSiteCategoryDropdown.jsx